// object to store loaded and loading wasm modules
var installedWasmModules = {};

function promiseResolve() { return Promise.resolve(); }

var wasmImportedFuncCache0;
var wasmImportedFuncCache1;
var wasmImportedFuncCache2;
var wasmImportedFuncCache3;
var wasmImportedFuncCache4;
var wasmImportedFuncCache5;
var wasmImportedFuncCache6;
var wasmImportedFuncCache7;
var wasmImportedFuncCache8;
var wasmImportedFuncCache9;
var wasmImportedFuncCache10;
var wasmImportedFuncCache11;
var wasmImportedFuncCache12;
var wasmImportedFuncCache13;
var wasmImportedFuncCache14;
var wasmImportedFuncCache15;
var wasmImportedFuncCache16;
var wasmImportedFuncCache17;
var wasmImportedFuncCache18;
var wasmImportedFuncCache19;
var wasmImportedFuncCache20;
var wasmImportedFuncCache21;
var wasmImportedFuncCache22;
var wasmImportedFuncCache23;
var wasmImportedFuncCache24;
var wasmImportedFuncCache25;
var wasmImportedFuncCache26;
var wasmImportedFuncCache27;
var wasmImportedFuncCache28;
var wasmImportedFuncCache29;
var wasmImportedFuncCache30;
var wasmImportedFuncCache31;
var wasmImportedFuncCache32;
var wasmImportedFuncCache33;
var wasmImportedFuncCache34;
var wasmImportedFuncCache35;
var wasmImportedFuncCache36;
var wasmImportedFuncCache37;
var wasmImportedFuncCache38;
var wasmImportedFuncCache39;
var wasmImportedFuncCache40;
var wasmImportedFuncCache41;
var wasmImportedFuncCache42;
var wasmImportedFuncCache43;
var wasmImportedFuncCache44;
var wasmImportObjects = {
	4626: function() {
		return {
			"./hed_json_patch_bg.js": {
				"__wbindgen_object_drop_ref": function(p0i32) {
					if(wasmImportedFuncCache0 === undefined) wasmImportedFuncCache0 = __webpack_require__.c[2866].exports;
					return wasmImportedFuncCache0["ug"](p0i32);
				},
				"__wbindgen_boolean_get": function(p0i32) {
					if(wasmImportedFuncCache1 === undefined) wasmImportedFuncCache1 = __webpack_require__.c[2866].exports;
					return wasmImportedFuncCache1["HT"](p0i32);
				},
				"__wbindgen_is_bigint": function(p0i32) {
					if(wasmImportedFuncCache2 === undefined) wasmImportedFuncCache2 = __webpack_require__.c[2866].exports;
					return wasmImportedFuncCache2["fW"](p0i32);
				},
				"__wbindgen_number_get": function(p0i32,p1i32) {
					if(wasmImportedFuncCache3 === undefined) wasmImportedFuncCache3 = __webpack_require__.c[2866].exports;
					return wasmImportedFuncCache3["M1"](p0i32,p1i32);
				},
				"__wbindgen_bigint_from_i64": function(p0i64) {
					if(wasmImportedFuncCache4 === undefined) wasmImportedFuncCache4 = __webpack_require__.c[2866].exports;
					return wasmImportedFuncCache4["WD"](p0i64);
				},
				"__wbindgen_jsval_eq": function(p0i32,p1i32) {
					if(wasmImportedFuncCache5 === undefined) wasmImportedFuncCache5 = __webpack_require__.c[2866].exports;
					return wasmImportedFuncCache5["Yq"](p0i32,p1i32);
				},
				"__wbindgen_string_get": function(p0i32,p1i32) {
					if(wasmImportedFuncCache6 === undefined) wasmImportedFuncCache6 = __webpack_require__.c[2866].exports;
					return wasmImportedFuncCache6["qt"](p0i32,p1i32);
				},
				"__wbindgen_is_object": function(p0i32) {
					if(wasmImportedFuncCache7 === undefined) wasmImportedFuncCache7 = __webpack_require__.c[2866].exports;
					return wasmImportedFuncCache7["uT"](p0i32);
				},
				"__wbindgen_in": function(p0i32,p1i32) {
					if(wasmImportedFuncCache8 === undefined) wasmImportedFuncCache8 = __webpack_require__.c[2866].exports;
					return wasmImportedFuncCache8["yb"](p0i32,p1i32);
				},
				"__wbindgen_bigint_from_u64": function(p0i64) {
					if(wasmImportedFuncCache9 === undefined) wasmImportedFuncCache9 = __webpack_require__.c[2866].exports;
					return wasmImportedFuncCache9["Kx"](p0i64);
				},
				"__wbindgen_error_new": function(p0i32,p1i32) {
					if(wasmImportedFuncCache10 === undefined) wasmImportedFuncCache10 = __webpack_require__.c[2866].exports;
					return wasmImportedFuncCache10["hd"](p0i32,p1i32);
				},
				"__wbindgen_jsval_loose_eq": function(p0i32,p1i32) {
					if(wasmImportedFuncCache11 === undefined) wasmImportedFuncCache11 = __webpack_require__.c[2866].exports;
					return wasmImportedFuncCache11["Qr"](p0i32,p1i32);
				},
				"__wbg_String_91fba7ded13ba54c": function(p0i32,p1i32) {
					if(wasmImportedFuncCache12 === undefined) wasmImportedFuncCache12 = __webpack_require__.c[2866].exports;
					return wasmImportedFuncCache12["RV"](p0i32,p1i32);
				},
				"__wbindgen_number_new": function(p0f64) {
					if(wasmImportedFuncCache13 === undefined) wasmImportedFuncCache13 = __webpack_require__.c[2866].exports;
					return wasmImportedFuncCache13["pT"](p0f64);
				},
				"__wbindgen_string_new": function(p0i32,p1i32) {
					if(wasmImportedFuncCache14 === undefined) wasmImportedFuncCache14 = __webpack_require__.c[2866].exports;
					return wasmImportedFuncCache14["h4"](p0i32,p1i32);
				},
				"__wbg_set_20cbc34131e76824": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache15 === undefined) wasmImportedFuncCache15 = __webpack_require__.c[2866].exports;
					return wasmImportedFuncCache15["Wl"](p0i32,p1i32,p2i32);
				},
				"__wbg_get_3baa728f9d58d3f6": function(p0i32,p1i32) {
					if(wasmImportedFuncCache16 === undefined) wasmImportedFuncCache16 = __webpack_require__.c[2866].exports;
					return wasmImportedFuncCache16["sm"](p0i32,p1i32);
				},
				"__wbg_length_ae22078168b726f5": function(p0i32) {
					if(wasmImportedFuncCache17 === undefined) wasmImportedFuncCache17 = __webpack_require__.c[2866].exports;
					return wasmImportedFuncCache17["mG"](p0i32);
				},
				"__wbg_new_a220cf903aa02ca2": function() {
					if(wasmImportedFuncCache18 === undefined) wasmImportedFuncCache18 = __webpack_require__.c[2866].exports;
					return wasmImportedFuncCache18["ak"]();
				},
				"__wbindgen_is_function": function(p0i32) {
					if(wasmImportedFuncCache19 === undefined) wasmImportedFuncCache19 = __webpack_require__.c[2866].exports;
					return wasmImportedFuncCache19["o$"](p0i32);
				},
				"__wbg_new_8608a2b51a5f6737": function() {
					if(wasmImportedFuncCache20 === undefined) wasmImportedFuncCache20 = __webpack_require__.c[2866].exports;
					return wasmImportedFuncCache20["wz"]();
				},
				"__wbg_next_de3e9db4440638b2": function(p0i32) {
					if(wasmImportedFuncCache21 === undefined) wasmImportedFuncCache21 = __webpack_require__.c[2866].exports;
					return wasmImportedFuncCache21["V5"](p0i32);
				},
				"__wbg_next_f9cb570345655b9a": function(p0i32) {
					if(wasmImportedFuncCache22 === undefined) wasmImportedFuncCache22 = __webpack_require__.c[2866].exports;
					return wasmImportedFuncCache22["eN"](p0i32);
				},
				"__wbg_done_bfda7aa8f252b39f": function(p0i32) {
					if(wasmImportedFuncCache23 === undefined) wasmImportedFuncCache23 = __webpack_require__.c[2866].exports;
					return wasmImportedFuncCache23["SG"](p0i32);
				},
				"__wbg_value_6d39332ab4788d86": function(p0i32) {
					if(wasmImportedFuncCache24 === undefined) wasmImportedFuncCache24 = __webpack_require__.c[2866].exports;
					return wasmImportedFuncCache24["aF"](p0i32);
				},
				"__wbg_iterator_888179a48810a9fe": function() {
					if(wasmImportedFuncCache25 === undefined) wasmImportedFuncCache25 = __webpack_require__.c[2866].exports;
					return wasmImportedFuncCache25["x9"]();
				},
				"__wbg_get_224d16597dbbfd96": function(p0i32,p1i32) {
					if(wasmImportedFuncCache26 === undefined) wasmImportedFuncCache26 = __webpack_require__.c[2866].exports;
					return wasmImportedFuncCache26["P7"](p0i32,p1i32);
				},
				"__wbg_call_1084a111329e68ce": function(p0i32,p1i32) {
					if(wasmImportedFuncCache27 === undefined) wasmImportedFuncCache27 = __webpack_require__.c[2866].exports;
					return wasmImportedFuncCache27["u9"](p0i32,p1i32);
				},
				"__wbg_new_525245e2b9901204": function() {
					if(wasmImportedFuncCache28 === undefined) wasmImportedFuncCache28 = __webpack_require__.c[2866].exports;
					return wasmImportedFuncCache28["R1"]();
				},
				"__wbindgen_is_string": function(p0i32) {
					if(wasmImportedFuncCache29 === undefined) wasmImportedFuncCache29 = __webpack_require__.c[2866].exports;
					return wasmImportedFuncCache29["eY"](p0i32);
				},
				"__wbg_set_673dda6c73d19609": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache30 === undefined) wasmImportedFuncCache30 = __webpack_require__.c[2866].exports;
					return wasmImportedFuncCache30["kd"](p0i32,p1i32,p2i32);
				},
				"__wbg_isArray_8364a5371e9737d8": function(p0i32) {
					if(wasmImportedFuncCache31 === undefined) wasmImportedFuncCache31 = __webpack_require__.c[2866].exports;
					return wasmImportedFuncCache31["IC"](p0i32);
				},
				"__wbg_instanceof_ArrayBuffer_61dfc3198373c902": function(p0i32) {
					if(wasmImportedFuncCache32 === undefined) wasmImportedFuncCache32 = __webpack_require__.c[2866].exports;
					return wasmImportedFuncCache32["Qm"](p0i32);
				},
				"__wbg_set_49185437f0ab06f8": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache33 === undefined) wasmImportedFuncCache33 = __webpack_require__.c[2866].exports;
					return wasmImportedFuncCache33["N9"](p0i32,p1i32,p2i32);
				},
				"__wbg_isSafeInteger_7f1ed56200d90674": function(p0i32) {
					if(wasmImportedFuncCache34 === undefined) wasmImportedFuncCache34 = __webpack_require__.c[2866].exports;
					return wasmImportedFuncCache34["Ix"](p0i32);
				},
				"__wbg_entries_7a0e06255456ebcd": function(p0i32) {
					if(wasmImportedFuncCache35 === undefined) wasmImportedFuncCache35 = __webpack_require__.c[2866].exports;
					return wasmImportedFuncCache35["eG"](p0i32);
				},
				"__wbg_buffer_b7b08af79b0b0974": function(p0i32) {
					if(wasmImportedFuncCache36 === undefined) wasmImportedFuncCache36 = __webpack_require__.c[2866].exports;
					return wasmImportedFuncCache36["BO"](p0i32);
				},
				"__wbg_new_ea1883e1e5e86686": function(p0i32) {
					if(wasmImportedFuncCache37 === undefined) wasmImportedFuncCache37 = __webpack_require__.c[2866].exports;
					return wasmImportedFuncCache37["dF"](p0i32);
				},
				"__wbg_set_d1e79e2388520f18": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache38 === undefined) wasmImportedFuncCache38 = __webpack_require__.c[2866].exports;
					return wasmImportedFuncCache38["eF"](p0i32,p1i32,p2i32);
				},
				"__wbg_length_8339fcf5d8ecd12e": function(p0i32) {
					if(wasmImportedFuncCache39 === undefined) wasmImportedFuncCache39 = __webpack_require__.c[2866].exports;
					return wasmImportedFuncCache39["aN"](p0i32);
				},
				"__wbg_instanceof_Uint8Array_247a91427532499e": function(p0i32) {
					if(wasmImportedFuncCache40 === undefined) wasmImportedFuncCache40 = __webpack_require__.c[2866].exports;
					return wasmImportedFuncCache40["_F"](p0i32);
				},
				"__wbindgen_bigint_get_as_i64": function(p0i32,p1i32) {
					if(wasmImportedFuncCache41 === undefined) wasmImportedFuncCache41 = __webpack_require__.c[2866].exports;
					return wasmImportedFuncCache41["zn"](p0i32,p1i32);
				},
				"__wbindgen_debug_string": function(p0i32,p1i32) {
					if(wasmImportedFuncCache42 === undefined) wasmImportedFuncCache42 = __webpack_require__.c[2866].exports;
					return wasmImportedFuncCache42["fY"](p0i32,p1i32);
				},
				"__wbindgen_throw": function(p0i32,p1i32) {
					if(wasmImportedFuncCache43 === undefined) wasmImportedFuncCache43 = __webpack_require__.c[2866].exports;
					return wasmImportedFuncCache43["Or"](p0i32,p1i32);
				},
				"__wbindgen_memory": function() {
					if(wasmImportedFuncCache44 === undefined) wasmImportedFuncCache44 = __webpack_require__.c[2866].exports;
					return wasmImportedFuncCache44["oH"]();
				}
			}
		};
	},
};

var wasmModuleMap = {
	"393": [
		4626
	]
};

// object with all WebAssembly.instance exports
__webpack_require__.w = {};

// Fetch + compile chunk loading for webassembly
__webpack_require__.f.wasm = function(chunkId, promises) {

	var wasmModules = wasmModuleMap[chunkId] || [];

	wasmModules.forEach(function(wasmModuleId, idx) {
		var installedWasmModuleData = installedWasmModules[wasmModuleId];

		// a Promise means "currently loading" or "already loaded".
		if(installedWasmModuleData)
			promises.push(installedWasmModuleData);
		else {
			var importObject = wasmImportObjects[wasmModuleId]();
			var req = fetch(__webpack_require__.p + "" + {"393":{"4626":"7b4b0000daeaa6e75222"}}[chunkId][wasmModuleId] + ".module.wasm");
			var promise;
			if(importObject && typeof importObject.then === 'function' && typeof WebAssembly.compileStreaming === 'function') {
				promise = Promise.all([WebAssembly.compileStreaming(req), importObject]).then(function(items) {
					return WebAssembly.instantiate(items[0], items[1]);
				});
			} else if(typeof WebAssembly.instantiateStreaming === 'function') {
				promise = WebAssembly.instantiateStreaming(req, importObject);
			} else {
				var bytesPromise = req.then(function(x) { return x.arrayBuffer(); });
				promise = bytesPromise.then(function(bytes) {
					return WebAssembly.instantiate(bytes, importObject);
				});
			}
			promises.push(installedWasmModules[wasmModuleId] = promise.then(function(res) {
				return __webpack_require__.w[wasmModuleId] = (res.instance || res).exports;
			}));
		}
	});
};